module.exports = __webpack_public_path__ + "img/death_knell_map.1843ad2c.png";